


export const Crm_START = 'Crm_START';
export const Crm_END = 'Crm_END';
export const Crm_ERROR = 'Crm_ERROR';
export const Crm_SUCCESS = 'Crm_SUCCESS';
export const Crm_FAIL = 'Crm_FAIL';

export const IsDataSubmitedSuccessfullyCrm = 'IsDataSubmitedSuccessfullyCrm'